import { useState, useEffect } from 'react';

export function useWifiStrength() {
  const [strength, setStrength] = useState(0);
  const [speedMbps, setSpeedMbps] = useState(0);
  console.log('speedMbps: ', speedMbps);
  const downloadSize = 1024 * 1024 * 5; // 5 MB test file
  const testImageUrl = 'https://github.com/BitDoctor/speed-test-file/blob/master/5mb.txt'; // Replace with actual test image URL

  // Function to determine signal strength (0-4) based on speed (Mbps)
  const getSignalStrength = (speed: number) => {
    if (speed >= 30) return 4; // Strong (30+ Mbps)
    if (speed >= 15) return 3; // Good (15-30 Mbps)
    if (speed >= 5) return 2; // Weak (5-15 Mbps)
    if (speed > 0) return 1; // Very Weak (0-5 Mbps)
    return 0; // No signal
  };

  // Function to calculate and log the download speed
  const calculateDownloadSpeed = (startTime: number) => {
    const endTime = new Date().getTime();
    const duration = (endTime - startTime) / 1000; // Time in seconds
    // console.log('duration: ', duration);
    const bitsLoaded = downloadSize * 8;
    const bps = bitsLoaded / duration; // Bits per second
    const kbps = bps / 1024; // Kilobits per second
    const mbps = kbps / 1024; // Megabits per second

    setSpeedMbps(parseFloat(mbps.toFixed(2))); // Store Mbps
    setStrength(getSignalStrength(mbps)); // Determine strength

    // Optionally, log the results to console for debugging
    console.log(`
      Download Speed:
      ${bps.toFixed(2)} bps
      ${kbps.toFixed(2)} kbps
      ${mbps.toFixed(2)} mbps
    `);
  };

  // Function to test download speed
  const startDownloadTest = async () => {
    const startTime = new Date().getTime();
    const download = new Image();

    // Start the image download
    download.src = `${testImageUrl}?${startTime}`;

    // Wait for the image to load (async/await syntax)
    await new Promise<void>((resolve, reject) => {
      download.onload = () => resolve(); // Resolve after image has loaded
      download.onerror = () => reject('Download failed'); // Reject on error
    })
      .then(() => {
        // If image loads successfully, calculate speed
        calculateDownloadSpeed(startTime);
      })
      .catch((error) => {
        // If an error occurs, calculate speed and handle error
        console.error(error); // Log error message
        calculateDownloadSpeed(startTime); // Calculate speed even if failed
      });
  };

  useEffect(() => {
    startDownloadTest(); // Run speed test

    // Optionally, retest speed every minute
    const interval = setInterval(startDownloadTest, 9000);
    return () => clearInterval(interval);
  }, []);

  return { strength, speedMbps }; // Returns 0-4 signal strength and speed in Mbps
}
